/**
 * Formata valores de QUANTIDADE no padrão pt-BR.
 * Regra: exibe casas após a vírgula apenas quando houver valor maior que zero.
 * Ex.: 1 -> "1" | 1,5 -> "1,50" | 1,05 -> "1,05" | 0,5 -> "0,50"
 */
export const formatQuantidade = (value) => {
  const num = parseFloat(value);
  if (isNaN(num)) return '';

  const frac = num % 1;
  if (frac === 0) {
    return new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(num);
  }
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

export default formatQuantidade;
